import FN from '../utility/fn'
import store from '../store'
// 1：登录 ，2：切换登出，3：支付，4：实名
const INDEX = {
  login: 1, // 登录
  updateData: 5, // 角色
  recharge: 3, // 支付
  changeAccount: 2, // 登出
  checkRealNameAuth: 4, // 实名
  exitGame: 7, // 退出游戏
  getDeviceInfo: 8 // 获取设备信息
}

const sendToOc = function (code, args, token) {
  return new Promise((resolve, reject) => {
    // jsBridge(token, {data: {a: 1, b: 2}})
    let personalMethod = {'method': 'gameBridge', code, args: JSON.stringify(args), token}
    window.webkit.messageHandlers.H5GAMESDK.postMessage(personalMethod)
    // window.webkit.messageHandlers.IOS_SmallClient.postMessage({'code': code, 'data': args, 'token': token, 'callback': callbackCode})
    resolve()
  })
}
const sendToAndroid = function (code, args, token) {
  return new Promise((resolve, reject) => {
    DXSDK.gameBridge(code, JSON.stringify(args), token)
    resolve()
  })
}
const updateRoleBase = (args, dataType) => {
  return {
    "dataType": dataType,
    "serverId": parseInt(args.serverId),
    "serverName": args.serverName,
    "roleId": args.roleId,
    "roleName": args.roleName,
    "roleLevel": parseInt(args.roleLevel),
    "professionId": parseInt(args.professionId),
    "profession": args.profession,
    "power": args.power,
    "vip": args.vipLevel,
    "roleGender": args.gender,
    "payTotal": args.payTotal,
    "remainCoinNum": args.userMoney,
    "partyId": args.partyid,
    "partyName": args.partyname,
    "partyRoleId": args.partyroleid,
    "partyRoleName": args.partyrolename,
    // "roleCreateTime": args.roleCTime,
    "roleCreateTime": args.roleCreateTime,
    "banlance": args.banlance ? '' : args.banlance,
    "friendShip": args.friendList ? '' : args.friendList,
    /** 上报类型为TYPE_LEVEL_UP 的时候传下面的参数**/
    // "roleLevelUpTime": args.roleLevelUpTime,
    "roleLevelUpTime": args.roleLevelUpTime,
    /** 上报类型为TYPE_TASK 的时候传下面的参数 任务统计 (任务完成时，不管是成功还是失败)**/
    "task_id": args.task_id,
    "task_name": args.task_name,
    "task_status": args.task_status,
    "transformLevel": args.transformLevel ? args.transformLevel : 0, // 传奇某些渠道需要的转生等级
    /** 上报类型为TYPE_HONOR 的时候传下面的参数 荣誉统计(一个角色可以获得多个荣誉 如:排行榜多少名、xx勋章、称号)**/
    "honor_id": args.honor_id,
    "honor_name": args.honor_name
  }
}
let CLIENTSDK = {
  init (token, args) {
    // 为客户端相应的事件保存token
    FN.saveSession('token', token)
    let data = {statusCode: 0, status: ''}
    FN.post({
      type: 'CC',
      token,
      payload: data
    })
  },
  // 登录
  login (token, args) {
    FN.log('EVENT:login', args)
    FN.saveSession('token', token)
    if (FN.isIOS) {
      // window.webkit.messageHandlers.IOS_SmallClient.postMessage({'code': INDEX.login, 'data': args, 'token': token, 'callback': INDEX.login})
      sendToOc(INDEX.login, args, token).then((res) => {
        console.log('发送给IOS成功')
      })
    } else {
      // gowanWebview.commonNativeMethod(code, JSON.stringify(args), token)
      sendToAndroid(INDEX.login, args, token).then((res) => {
        // console.log('发送给安卓成功')
      })
    }

    if (!window.FUSESDKAPI.flymeChangeAccount) return
    window.FUSESDKAPI.flymeChangeAccount({
      token,
      data: {
        // TODO
        loginWay: ''
      },
      callback: (data = {}) => {
        FN.post({
          type: 'CCF',
          token: token,
          payload: data
        })
      }
    })
  },
  // 登出
  changeAccount (token, args) {
    FN.log('EVENT:changeAccount', args)
    if (FN.isIOS) {
      sendToOc(INDEX.changeAccount, args, token).then((res) => {
        console.log('发送IOS成功')
      })
    } else {
      sendToAndroid(INDEX.changeAccount, args, token).then((res) => {
        console.log('发送安卓成功=========登出')
      })
    }

    let data = {statusCode: 0, status: ''}
    FN.post({
      type: 'CC',
      token: token,
      payload: data
    })
  },
  // SDK切换账号
  flymeChangeAccount (token, args) {
    FN.log('EVENT:flymeChangeAccount')
    // 为客户端相应的事件保存token
    FN.saveSession('token', token)

    if (FN.isIOS) {
      sendToOc(INDEX.changeAccount, args, token).then((res) => {
        console.log('发送IOS成功')
      })
    } else {
      sendToAndroid(INDEX.changeAccount, args, token).then((res) => {
        console.log('发送安卓成功=========登出')
      })
    }
  },
  // 实名
  flymeCheckRealNameAuth(token, args) {

  },
  // 支付
  recharge (token, args) {
    // 为客户端相应的事件保存token
    FN.saveSession('token', token)
    if (FN.isIOS) {
      sendToOc(INDEX.recharge, args, token).then((res) => {
        let data = {statusCode: 0, status: '调用支付成功'}
        FN.post({
          type: 'CC',
          token,
          payload: data
        })
      })
    } else {
      let agrs1 = {
        "buyNum": args.chargeMount,
        "callBackUrl": args.callbackURL,
        "extension": args.callbackInfo,
        "orderId": args.orderId,
        "partyName": args.sociaty,
        "per_price": args.per_price || '',
        "productDesc": args.chargeDesc,
        "productId": args.cpProductId,
        "productName": args.productName,
        "ratio": parseInt(args.rate) || '',
        "remainCoinNum": parseInt(args.lastMoney),
        "roleId": args.roleId,
        "roleLevel": parseInt(args.roleLevel),
        "roleName": args.roleName,
        "serverId": parseInt(args.serverId),
        "serverName": args.serverName,
        "time": new Date().getTime(),
        "totalPrice": parseInt(args.amount),
        "vip": args.vipLevel
      }
      let param = agrs1
      // object
      console.log('=======支付=============')
      console.log(param)
      // let param = JSON.stringify({a: 11111, b: 2222, c: '我是蛋蛋'})
      sendToAndroid(INDEX.recharge, param, token).then((res) => {
        let data = {statusCode: 0, status: '调用支付成功'}
        FN.post({
          type: 'CC',
          token,
          payload: data
        })
        console.log('发送给安卓成功=========支付')
      })
    }
  },
  // 角色创建
  createRole (token, args) {
    // FN.log('EVENT:createRole', args)
    // 为客户端相应的事件保存token
    FN.saveSession('token', token)
    // let dataType = 2
    // let updateData = {
    //   ...args,
    //   dataType
    // }
    let updateData = updateRoleBase(args, 2)
    console.log('=====角色上报========')
    console.log(updateData)
    if (FN.isIOS) {
      sendToOc(INDEX.updateData, updateData, token).then((res) => {
        let data = {statusCode: 0, status: ''}
        FN.post({
          type: 'CC',
          token,
          payload: data
        })
      })
    } else {
      sendToAndroid(INDEX.updateData, updateData, token).then((res) => {
        let data = {statusCode: 0, status: ''}
        FN.post({
          type: 'CC',
          token,
          payload: data
        })
        console.log('发送给安卓成功========角色信息上报')
      })
    }
  },
  // 切换角色登录
  changeRole (token, args) {
    console.log('角色登录=============================')
    // 为客户端相应的事件保存token
    FN.saveSession('token', token)
    // let dataType = 3
    // let updateData = {
    //   ...args,
    //   dataType
    // }
    let updateData = updateRoleBase(args, 3)
    console.log(INDEX.updateData, updateData, token)
    if (FN.isIOS) {
      sendToOc(INDEX.updateData, updateData, token).then((res) => {
        let data = {statusCode: 0, status: ''}
        FN.post({
          type: 'CC',
          token,
          payload: data
        })
      })
    } else {
      sendToAndroid(INDEX.updateData, updateData, token).then((res) => {
        let data = {statusCode: 0, status: ''}
        FN.post({
          type: 'CC',
          token,
          payload: data
        })
        console.log('发送给安卓成功========角色信息上报')
      })
    }
  },
  // 角色升级
  upgradeRole (token, args) {
    // 为客户端相应的事件保存token
    FN.saveSession('token', token)
    // let dataType = 4
    // let updateData = {
    //   ...args,
    //   dataType
    // }
    let updateData = updateRoleBase(args, 4)
    if (FN.isIOS) {
      sendToOc(INDEX.updateData, updateData, token).then((res) => {
        let data = {statusCode: 0, status: ''}
        FN.post({
          type: 'CC',
          token,
          payload: data
        })
      })
    } else {
      sendToAndroid(INDEX.updateData, updateData, token).then((res) => {
        let data = {statusCode: 0, status: ''}
        FN.post({
          type: 'CC',
          token,
          payload: data
        })
        console.log('发送给安卓成功========角色信息上报')
      })
    }
  },
  // 选择服务器上报数据
  slectServe (token, args) {
    // 为客户端相应的事件保存token
    FN.saveSession('token', token)
    // let dataType = 1
    // let updateData = {
    //   ...args,
    //   dataType
    // }
    let updateData = updateRoleBase(args, 1)
    if (FN.isIOS) {
      sendToOc(INDEX.updateData, updateData, token).then((res) => {
        let data = {statusCode: 0, status: ''}
        FN.post({
          type: 'CC',
          token,
          payload: data
        })
      })
    } else {
      sendToAndroid(INDEX.updateData, updateData, token).then((res) => {
        let data = {statusCode: 0, status: ''}
        FN.post({
          type: 'CC',
          token,
          payload: data
        })
        console.log('发送给安卓成功========角色信息上报')
      })
    }
  },
  // 结束任务上报数据
  task (token, args) {
    // 为客户端相应的事件保存token
    FN.saveSession('token', token)
    // let dataType = 6
    // let updateData = {
    //   ...args,
    //   dataType
    // }
    let updateData = updateRoleBase(args, 6)
    if (FN.isIOS) {
      sendToOc(INDEX.updateData, updateData, token).then((res) => {
        let data = {statusCode: 0, status: ''}
        FN.post({
          type: 'CC',
          token,
          payload: data
        })
      })
    } else {
      sendToAndroid(INDEX.updateData, updateData, token).then((res) => {
        let data = {statusCode: 0, status: ''}
        FN.post({
          type: 'CC',
          token,
          payload: data
        })
        console.log('发送给安卓成功========角色信息上报')
      })
    }
  },
  // 获得荣耀上报数据
  honor (token, args) {
    // 为客户端相应的事件保存token
    FN.saveSession('token', token)
    // let dataType = 7
    // let updateData = {
    //   ...args,
    //   dataType
    // }
    let updateData = updateRoleBase(args, 7)
    if (FN.isIOS) {
      sendToOc(INDEX.updateData, updateData, token).then((res) => {
        let data = {statusCode: 0, status: ''}
        FN.post({
          type: 'CC',
          token,
          payload: data
        })
      })
    } else {
      sendToAndroid(INDEX.updateData, updateData, token).then((res) => {
        let data = {statusCode: 0, status: ''}
        FN.post({
          type: 'CC',
          token,
          payload: data
        })
        console.log('发送给安卓成功========角色信息上报')
      })
    }
  },
  // 获取当前用户ID
  getUserID (token, args) {
    let UserId = FN.getSession('CLIENT_FUSE_USER_INFO').user_id
    let data = {statusCode: 0, status: UserId}
    FN.post({
      type: 'CC',
      token,
      payload: data
    })
  },
  // 获取渠道分发id
  getFromID (token, args) {
    // 为客户端相应的事件保存token
    FN.saveSession('token', token)
    let FromID = FN.getSession('FUSE_CHANNEL_INFO').package_id
    let data = {statusCode: 0, status: FromID}
    FN.post({
      type: 'CC',
      token,
      payload: data
    })
  },
  // 获取手机系统
  getPlatform (token, args) {
    // 为客户端相应的事件保存token
    FN.saveSession('token', token)
    let OS = FN.getSession('FUSE_CHANNEL_INFO').os
    let data = {os: OS}
    FN.post({
      type: 'CC',
      token,
      payload: data
    })
  },
  // 实名认证查询
  checkRealNameAuth (token, args) {
    if (FN.isIOS) {
      sendToOc(INDEX.checkRealNameAuth, args, token).then((res) => {
        console.log('发送给IOS成功')
      })
    } else {
      sendToAndroid(INDEX.checkRealNameAuth, args, token).then((res) => {
        console.log('查询实名')
        console.log('发送给安卓成功========查询实名')
      })
    }
    if (!window.FUSESDKAPI.checkRealNameAuth) return
    window.FUSESDKAPI.checkRealNameAuth({
      token,
      data: {
        // TODO
        loginWay: ''
      },
      callback: (data = {}) => {
        FN.post({
          type: 'CC',
          token: token,
          payload: data
        })
      }
    })
  },
  // 获取手机系统
  exitGame (token, args) {
    // 为客户端相应的事件保存token
    if (FN.isIOS) {
      sendToOc(INDEX.exitGame, args, token).then((res) => {
        console.log('发送给IOS成功')
      })
    } else {
      sendToAndroid(INDEX.exitGame, args, token).then((res) => {
        console.log('发送给安卓成功')
      })
    }
  },
  // 获取设备信息（屏幕宽高，刘海大小）
  getDeviceInfo (token, args) {
    if (FN.isIOS) {
      sendToOc(INDEX.getDeviceInfo, args, token).then((res) => {
        console.log('发送给IOS成功')
      })
    } else {
      sendToAndroid(INDEX.getDeviceInfo, args, token).then((res) => {
        console.log('发送给安卓成功')
      })
    }
  }
}

export {
  CLIENTSDK
}
